var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworkstep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4453_51831)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#EBEEF4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4453_51831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9428 26.0006V55.2808H18.3818V22.549H14.6619L10.9428 26.0006Z",
    fill: "#41CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3003 23.1542H18.3818V55.2812H15.3003V23.1542Z",
    fill: "#209476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9435 26.0006V55.2808H14.6626V22.549L10.9435 26.0006Z",
    fill: "#209476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9423 26.8628V55.2809H14.3247V23.7236L10.9423 26.8628Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.943 27.1017V55.2808H14.2378V24.0437L10.943 27.1017Z",
    fill: "#1A7860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3003 23.1542H18.3818V23.3599H15.3003V23.1542Z",
    fill: "#1A7860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 24.4172H18.3818V24.6002H15.7981V24.4172Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 25.5662H18.3818V25.7491H15.7981V25.5662Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 26.7148H18.3818V26.8978H15.7981V26.7148Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 27.8639H18.3818V28.0468H15.7981V27.8639Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 29.0129H18.3818V29.1959H15.7981V29.0129Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 30.1616H18.3818V30.3445H15.7981V30.1616Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 31.3107H18.3818V31.4936H15.7981V31.3107Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 32.4597H18.3818V32.6426H15.7981V32.4597Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 33.608H18.3818V33.7909H15.7981V33.608Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 34.757H18.3818V34.9399H15.7981V34.757Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 35.906H18.3818V36.0889H15.7981V35.906Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 37.0547H18.3818V37.2376H15.7981V37.0547Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 38.2037H18.3818V38.3867H15.7981V38.2037Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 39.3528H18.3818V39.5357H15.7981V39.3528Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 40.5015H18.3818V40.6844H15.7981V40.5015Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 41.6505H18.3818V41.8334H15.7981V41.6505Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 42.7994H18.3818V42.9824H15.7981V42.7994Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 43.9481H18.3818V44.131H15.7981V43.9481Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 45.0972H18.3818V45.2801H15.7981V45.0972Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 46.2462H18.3818V46.4291H15.7981V46.2462Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 47.3949H18.3818V47.5778H15.7981V47.3949Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 48.5439H18.3818V48.7269H15.7981V48.5439Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 49.693H18.3818V49.8759H15.7981V49.693Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 50.8413H18.3818V51.0242H15.7981V50.8413Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 51.9906H18.3818V52.1735H15.7981V51.9906Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7981 53.1396H18.3818V53.3226H15.7981V53.1396Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 27.8639H12.125V28.0468H10.9432V27.8639Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 29.0129H12.125V29.1959H10.9432V29.0129Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 30.1616H12.125V30.3445H10.9432V30.1616Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 31.3107H12.125V31.4936H10.9432V31.3107Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 32.4597H12.125V32.6426H10.9432V32.4597Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 33.6084H12.125V33.7913H10.9432V33.6084Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 34.7573H12.125V34.9402H10.9432V34.7573Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 35.9064H12.125V36.0893H10.9432V35.9064Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 37.0547H12.125V37.2376H10.9432V37.0547Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 38.2037H12.125V38.3866H10.9432V38.2037Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 39.3528H12.125V39.5357H10.9432V39.3528Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 40.5015H12.125V40.6844H10.9432V40.5015Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 41.6505H12.125V41.8334H10.9432V41.6505Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 42.7994H12.125V42.9824H10.9432V42.7994Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 43.9481H12.125V44.131H10.9432V43.9481Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 45.0972H12.125V45.2801H10.9432V45.0972Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 46.2462H12.125V46.4291H10.9432V46.2462Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 47.3949H12.125V47.5778H10.9432V47.3949Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 48.5439H12.125V48.7269H10.9432V48.5439Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 49.693H12.125V49.8759H10.9432V49.693Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 50.8417H12.125V51.0246H10.9432V50.8417Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 51.9906H12.125V52.1735H10.9432V51.9906Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 53.1396H12.125V53.3226H10.9432V53.1396Z",
    fill: "#073937"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4453_51831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4603 17.3497V55.2808H31.7896V12.8782H36.6255L41.4603 17.3497Z",
    fill: "#41CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7956 13.6622H31.7896V55.2813H35.7956V13.6622Z",
    fill: "#209476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4598 17.3497V55.2808H36.625V12.8782L41.4598 17.3497Z",
    fill: "#209476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4616 18.4664V55.2807H37.0645V14.3997L41.4616 18.4664Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46 18.776V55.2807H37.1768V14.8145L41.46 18.776Z",
    fill: "#1A7860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7956 13.6622H31.7896V13.9287H35.7956V13.6622Z",
    fill: "#1A7860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 15.2985H31.7896V15.5354H35.1484V15.2985Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 16.7871H31.7896V17.0241H35.1484V16.7871Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 18.2751H31.7896V18.5121H35.1484V18.2751Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 19.7634H31.7896V20.0004H35.1484V19.7634Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 21.2521H31.7896V21.489H35.1484V21.2521Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 22.7401H31.7896V22.9771H35.1484V22.7401Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 24.2284H31.7896V24.4654H35.1484V24.2284Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 25.717H31.7896V25.954H35.1484V25.717Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 27.2051H31.7896V27.442H35.1484V27.2051Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 28.6934H31.7896V28.9303H35.1484V28.6934Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 30.182H31.7896V30.419H35.1484V30.182Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 31.6699H31.7896V31.9069H35.1484V31.6699Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 33.1583H31.7896V33.3953H35.1484V33.1583Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 34.647H31.7896V34.8839H35.1484V34.647Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 36.1349H31.7896V36.3718H35.1484V36.1349Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 37.6237H31.7896V37.8606H35.1484V37.6237Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 39.1119H31.7896V39.3489H35.1484V39.1119Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 40.5999H31.7896V40.8368H35.1484V40.5999Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 42.0886H31.7896V42.3256H35.1484V42.0886Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 43.5769H31.7896V43.8139H35.1484V43.5769Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 45.0648H31.7896V45.3018H35.1484V45.0648Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 46.5535H31.7896V46.7904H35.1484V46.5535Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 48.0419H31.7896V48.2788H35.1484V48.0419Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 49.5298H31.7896V49.7667H35.1484V49.5298Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 51.0184H31.7896V51.2554H35.1484V51.0184Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 52.5068H31.7896V52.7438H35.1484V52.5068Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1484 53.9948H31.7896V54.2317H35.1484V53.9948Z",
    fill: "#0C625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 19.7634H39.9238V20.0004H41.4601V19.7634Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 21.2521H39.9238V21.489H41.4601V21.2521Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 22.7401H39.9238V22.9771H41.4601V22.7401Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 24.2284H39.9238V24.4654H41.4601V24.2284Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 25.717H39.9238V25.954H41.4601V25.717Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 27.2051H39.9238V27.442H41.4601V27.2051Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 28.6934H39.9238V28.9303H41.4601V28.6934Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 30.182H39.9238V30.419H41.4601V30.182Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 31.6699H39.9238V31.9069H41.4601V31.6699Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 33.1583H39.9238V33.3953H41.4601V33.1583Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 34.647H39.9238V34.8839H41.4601V34.647Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 36.1349H39.9238V36.3718H41.4601V36.1349Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 37.6233H39.9238V37.8602H41.4601V37.6233Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 39.1119H39.9238V39.3489H41.4601V39.1119Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 40.5999H39.9238V40.8368H41.4601V40.5999Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 42.0886H39.9238V42.3256H41.4601V42.0886Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 43.5769H39.9238V43.8139H41.4601V43.5769Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 45.0648H39.9238V45.3018H41.4601V45.0648Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 46.5535H39.9238V46.7904H41.4601V46.5535Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 48.0419H39.9238V48.2788H41.4601V48.0419Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 49.5298H39.9238V49.7667H41.4601V49.5298Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 51.0184H39.9238V51.2554H41.4601V51.0184Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 52.5068H39.9238V52.7438H41.4601V52.5068Z",
    fill: "#073937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4601 53.9948H39.9238V54.2317H41.4601V53.9948Z",
    fill: "#073937"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4453_51831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5638 -2.03748H26.3711V8.74625H26.5638V-2.03748Z",
    fill: "#0C121F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9383 37.0558V56.3239H21.5V23.121L36.9383 37.0558Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4668 6.91064V31.3868L29.8182 34.4214V9.93503L26.4668 6.91064Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4668 9.26892V30.9143L29.0491 33.2523V11.5998L26.4668 9.26892Z",
    fill: "#0C121F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1794 15.6213H22.8042V16.1118H28.1794V15.6213Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1794 17.0776H22.8042V17.5688H28.1794V17.0776Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1794 18.5356H22.8042V19.0261H28.1794V18.5356Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1794 19.9937H22.8042V20.4841H28.1794V19.9937Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1794 21.4498H22.8042V21.941H28.1794V21.4498Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1794 22.9076H22.8042V23.398H28.1794V22.9076Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1805 24.3656H23.8521V24.856H28.1805V24.3656Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1802 14.1637H24.3213V14.6541H28.1802V14.1637Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1791 25.8218H25.6187V26.313H28.1791V25.8218Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1798 12.7057H26.2329V13.1969H28.1798V12.7057Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4671 -2.03748H26.2744V8.74625H26.4671V-2.03748Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4666 6.91064V30.7074L19.6497 24.3524L18.7471 23.5117V13.8781L26.4666 6.91064Z",
    fill: "#3F4E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4678 9.26892V30.7073L19.6509 24.3523V15.4216L26.4678 9.26892Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1853 37.0558V56.3239H18.7471V23.121L34.1853 37.0558Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9217 39.4201V56.3242H18.7471V26.6259L32.9217 39.4201Z",
    fill: "#38455E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4676 15.4357H20.9014V16.1119H26.4676V15.4357Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4676 16.8918H20.9014V17.5688H26.4676V16.8918Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4676 18.35H20.9014V19.0262H26.4676V18.35Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4676 19.808H20.9014V20.4842H26.4676V19.808Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4676 21.2649H20.9014V21.9419H26.4676V21.2649Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4676 22.7218H20.9014V23.398H26.4676V22.7218Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4674 24.1799H21.9487V24.8561H26.4674V24.1799Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.468 13.978H22.418V14.6542H26.468V13.978Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4669 25.6368H23.7153V26.3138H26.4669V25.6368Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4667 12.52H24.3296V13.197H26.4667V12.52Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4675 15.6213H21.0923V16.1118H26.4675V15.6213Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4675 17.0776H21.0923V17.5688H26.4675V17.0776Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4675 18.5356H21.0923V19.0261H26.4675V18.5356Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4675 19.9937H21.0923V20.4841H26.4675V19.9937Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4675 21.4498H21.0923V21.941H26.4675V21.4498Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4675 22.9076H21.0923V23.398H26.4675V22.9076Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4671 24.3656H22.1387V24.856H26.4671V24.3656Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4678 14.1637H22.6089V14.6541H26.4678V14.1637Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4667 25.8218H23.9062V26.313H26.4667V25.8218Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4674 12.7057H24.5205V13.1969H26.4674V12.7057Z",
    fill: "#4D5F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3133 33.8425H18.7471V34.5187H24.3133V33.8425Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9364 35.2988H18.7471V35.9758H25.9364V35.2988Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.655 36.7568H18.7471V37.433H27.655V36.7568Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4691 38.2148H18.7471V38.891H29.4691V38.2148Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0922 39.6711H18.7471V40.3481H31.0922V39.6711Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0922 41.1288H18.7471V41.805H31.0922V41.1288Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1877 42.5868H18.7471V43.263H31.1877V42.5868Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7971 32.3849H18.7471V33.0611H22.7971V32.3849Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1877 44.0437H18.7471V44.7207H31.1877V44.0437Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8842 30.9269H18.7471V31.6039H20.8842V30.9269Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1222 34.0282H18.7471V34.5186H24.1222V34.0282Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7453 35.4849H18.7471V35.9761H25.7453V35.4849Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4647 36.9425H18.7471V37.4329H27.4647V36.9425Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2789 38.4005H18.7471V38.8909H29.2789V38.4005Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9019 39.8568H18.7471V40.348H30.9019V39.8568Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9019 41.3148H18.7471V41.8052H30.9019V41.3148Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9975 42.7725H18.7471V43.2629H30.9975V42.7725Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.606 32.5706H18.7471V33.061H22.606V32.5706Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9975 44.2288H18.7471V44.72H30.9975V44.2288Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0922 45.5011H18.7471V46.1781H31.0922V45.5011Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0922 46.9587H18.7471V47.6349H31.0922V46.9587Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1877 48.4167H18.7471V49.0929H31.1877V48.4167Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1877 49.8729H18.7471V50.5499H31.1877V49.8729Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9019 45.6868H18.7471V46.178H30.9019V45.6868Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9019 47.1444H18.7471V47.6348H30.9019V47.1444Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9975 48.6024H18.7471V49.0928H30.9975V48.6024Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9975 50.0587H18.7471V50.5499H30.9975V50.0587Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0922 51.3311H18.7471V52.008H31.0922V51.3311Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0922 52.7887H18.7471V53.4649H31.0922V52.7887Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9019 51.5167H18.7471V52.0079H30.9019V51.5167Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9019 52.9744H18.7471V53.4648H30.9019V52.9744Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.694 31.1125H18.7471V31.6038H20.694V31.1125Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 38.2148H34.9004V38.891H36.9371V38.2148Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 39.6711H34.9004V40.3481H36.9371V39.6711Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 41.1292H34.9004V41.8053H36.9371V41.1292Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 42.5868H34.9004V43.263H36.9371V42.5868Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 44.0433H34.9004V44.7203H36.9371V44.0433Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 45.5011H34.9004V46.1781H36.9371V45.5011Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 46.9591H34.9004V47.6353H36.9371V46.9591Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 48.4167H34.9004V49.0929H36.9371V48.4167Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 49.8729H34.9004V50.5499H36.9371V49.8729Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 51.3311H34.9004V52.008H36.9371V51.3311Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 52.7891H34.9004V53.4653H36.9371V52.7891Z",
    fill: "#213150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 38.4005H34.9004V38.8909H36.9371V38.4005Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 39.8568H34.9004V40.348H36.9371V39.8568Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 41.3148H34.9004V41.8052H36.9371V41.3148Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 42.7725H34.9004V43.2629H36.9371V42.7725Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 44.229H34.9004V44.7202H36.9371V44.229Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 45.6868H34.9004V46.178H36.9371V45.6868Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 47.1448H34.9004V47.6352H36.9371V47.1448Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 48.6024H34.9004V49.0928H36.9371V48.6024Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 50.0587H34.9004V50.5499H36.9371V50.0587Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 51.5167H34.9004V52.0079H36.9371V51.5167Z",
    fill: "#121C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9371 52.9747H34.9004V53.4651H36.9371V52.9747Z",
    fill: "#121C30"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4453_51831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4453_51831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.43906,
    height: 32.7319,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.3818 22.549)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4453_51831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.67078,
    height: 42.4027,
    fill: "white",
    transform: "translate(31.7896 12.8782)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4453_51831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1906,
    height: 58.3615,
    fill: "white",
    transform: "translate(18.7471 -2.03748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworkstep1);
export default __webpack_public_path__ + "static/media/howitworkstep1.56f439d94dd68e64110e5852b0461e73.svg";
export { ForwardRef as ReactComponent };